import React, {PureComponent, ChangeEvent, CSSProperties} from 'react'
import cxs from 'cxs/component'
import Theme, {mediaQueries} from 'Theme'
import {t} from 'helpers/i18n'
import {Button, TimePicker, Input} from 'elements'

interface Props {
  name: string
  column?: string
  hora: {hours: number, minutes: number}
  required?: boolean
  onChange(name: string, hour: {}, column?: string): void
}

class FieldTime extends PureComponent<Props, {}> {
  render() {
    const {hora, name, required, onChange} = this.props
    return (
        <TimePicker
          name={name}
          hora={hora}
          onChange={onChange}
        />
    )
  }
}

export default FieldTime

const Label = cxs('label')({
  padding: Theme.size.space[1],
  color: Theme.color.placeholder
} as CSSProperties)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/elements/FieldTime.tsx